import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const PlanningListContainer = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 30px;
  box-shadow: 2px 4px 4px 0 rgb(0 0 0 / 25%);
  background-color: white;
  padding-bottom: 30px;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  .table-container {
    padding: 0 30px;
  }
`;

export const OuterWrapper = styled.div`
  padding: 1rem;
`;

export const Title = styled.h2`
  width: 100%;
  text-align: center;
  font-family: "Lato";
  font-size: 22px;
  line-height: 22px;
  margin: 0 0 30px 0;
  color: #ff5200;
  text-transform: capitalize;
  font-weight: bold;
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  > div {
    margin-right: 0.5rem;
  }
`;

export const FilterFlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  align-items: center;
`;
export const FilterOuter = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 74%;
  column-gap: 1rem;
`;
export const OrderServiceInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;
export const HeaderGridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gridGap ?? "1.25rem;"};
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
  font-weight: normal;
  margin-top: ${(props) => props.marginTop ?? "10px"};
`;
export const GridItem = styled.div`
  border-right: ${(props) => props.borderRight ?? "2px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  text-align: ${(props) => props.textAlign ?? "center"};
  color: #fff;
  font-weight: ${(props) => props.fontWeight ?? "400"};
  background-color: ${(props) => props.backgroundColor ?? "#0A4986"};
  padding: ${(props) => props.padding ?? "10px"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  border-radius: ${(props) => props.radius ?? "0px 0px 0px 0px"};
  align-content: ${(props) => props.alignContent ?? "flex-start"};
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gap ?? "1.25rem"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
  font-weight: normal;
  gap: ${(props) => props.padding ?? "0px"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
`;

export const PlanningServiceInfo = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: 2px 2px 4px 1px rgba(0, 76, 127, 0.25);
  background-color: white;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;

export const HeaderWrapperTable = styled.div`
  background-color: #fff;
  display: table-column-group;
  justify-content: space-between;
  border-radius: 0px 0px 0px 0px;
`;

export const GridSubLabel = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-weight: ${(props) => props.fontWeight ?? "700"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  text-align: ${(props) => props.textAlign ?? "left"};
`;

export const GridSubLabelContent = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-weight: ${(props) => props.fontWeight ?? "700"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  text-align: ${(props) => props.textAlign ?? "left"};
  align-content: center;
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
  padding: ${(props) => props.padding ?? "5px"};
  align-content: ${(props) => props.alignContent ?? "center"};
`;

export const FlexRowHeader = styled.div`
  background-color: #008395;
  display: flex;
  justify-content: flex-start;
  padding: ${(props) => props.padding ?? "10px"};
  display: flex;
  font-size: 16px;
  font-weight: 700;
  border-radius: 0px;
  :before {
    content: "";
    position: relative;
    margin-right: -10px;
    bottom: 0;
    width: 35px;
    height: 0;
    border-left: 10px solid #fff;
    border-top: 20px solid transparent;
    border-bottom: 20px solid transparent;
  }
`;

export const ServiceTitle = styled.h3`
  color: white !important;
  margin: 0px;
  text-align: left;
  width: auto;
  font-family: "Lato";
  font-size: 20px;
  line-height: 20px;
  margin-top: 7px;
  font-weight: ${(props) => props.fontWeight ?? "normal"};
`;

export const IconDiv = styled.div`
  background-color: rgb(0, 131, 149);
  padding: 4px 10px 4px 4px;
`;

export const GridRowWithHeight = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gap ?? "1.25rem"};
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
  font-weight: normal;
  gap: ${(props) => props.padding ?? "0px"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
  line-height: 1.2rem;
`;

export const SolutionIdLink = styled.span`
  text-decoration: underline;
  cursor: pointer;
  color: ${(props) => props.color ?? "#0A4986"};
`;

export const ButtonWrapper = styled.div`
  text-align: right;
  position: relative;
`;
